import styled from 'styled-components';
import { colorPalette, getSpacing, typography } from 'stylesheet';

export const DialogBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${getSpacing(3)};
  min-width: 360px;
  max-width: 520px;

  @media (max-width: 600px) {
    min-width: 0;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${getSpacing(1)};
`;

export const SectionLabel = styled.span`
  ${typography.p1_bold};
  color: ${colorPalette.greyMain};
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${getSpacing(1)};
`;

export const HelperText = styled.span`
  ${typography.p1_regular};
  color: ${colorPalette.grey_600};
`;

export const ErrorText = styled.span`
  ${typography.p1_regular};
  color: ${colorPalette.status_error};
`;

export const DialogActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${getSpacing(2)};
  margin-top: ${getSpacing(1)};
`;
